import script from "./Show3DModelPage.vue?vue&type=script&setup=true&lang=js"
export * from "./Show3DModelPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__